import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
  OnDestroy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ToastrService } from 'ngx-toastr';
import { MatDatepicker } from '@angular/material/datepicker';
import { NgxMatTimepickerComponent } from 'ngx-mat-timepicker';
import { DateTime } from 'ts-luxon';
import { SignupService } from 'src/app/services/signup.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { error } from 'console';
import { switchMap } from 'rxjs';
@Component({
  selector: 'dialog-b2bArrangePickup',
  templateUrl: 'b2b-arrange-pickup-dialog.html',
  styleUrls: ['./b2b-arrange-pickup-dialog.css'],
})
export class B2BArrangePickupDialog implements OnDestroy, OnInit {
  token: string;
  userID: string;

  form = new UntypedFormGroup({
    dropPackageMyself: new UntypedFormControl(false),
    pickUpDate: new UntypedFormControl('', [Validators.required]),
    pickUpAddress: new UntypedFormControl('initial', [Validators.required]),
    moreThanOneBox: new UntypedFormControl('', [Validators.required]),
    startTime: new UntypedFormControl('', [Validators.required]),
    endTime: new UntypedFormControl('', [Validators.required]),
  });

  shipment: any = {};
  addressesList: any[] = [];

  addressId: string | null = null;


  ngOnDestroy(): void {
    this.form.reset();
    this.shipment = {};
    this.addressesList = [];
    this.addressId = null;
  }

  constructor(
    public dialogRef: MatDialogRef<B2BArrangePickupDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private signUpService: SignupService,
    private store: Store<AppState>,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.store.select('auth').subscribe((state) => {
      this.token = state.token;
      this.userID = state.user?.id;
    });

    this.shipment = this.data?.shipment;
    this.addressesList = this.data?.addresses;
    this.addressId = this.findMatchingAddressId(
      this.addressesList,
      this.shipment.b2b_user_address
    );

    if (this.addressId == null) {
      this.toastr.error('Address not found! Please contact our support team for guidance. ', 'Error');
      this.dialogRef.close();
    }
  }

  findMatchingAddressId(addressList, b2bUserAddress) {
    return (
      addressList.find(
        (address) =>
          address.line1.trim().toLowerCase() ===
            b2bUserAddress.street1.trim().toLowerCase() &&
          address.line2.trim().toLowerCase() ===
            b2bUserAddress.street2.trim().toLowerCase() &&
          address.state.trim().toLowerCase() ===
            b2bUserAddress.state.trim().toLowerCase() &&
          address.city_name.trim().toLowerCase() ===
            b2bUserAddress.city.trim().toLowerCase()
      )?.id || null
    );
  }
  closeWithoutAddItem(): void {
    this.dialogRef.close();
  }



  // * Timepicker

  maxStartTime: DateTime = DateTime.local().startOf('day').set({
    hour: 15,
    minute: 0,
  });
  minStartTime: DateTime = DateTime.local().startOf('day').set({
    hour: 9,
    minute: 0,
  });
  minEndTime: DateTime = DateTime.local().startOf('day').set({
    hour: 12,
    minute: 0,
  });
  maxEndTime: DateTime = DateTime.local().startOf('day').set({
    hour: 18,
    minute: 0,
  });
  selectedTime;
  isEndTimeSelectable = true;

  selectedFromTime = null;
  selectedToTime = null;

  @ViewChild('pickerA') pickerA: NgxMatTimepickerComponent;
  @ViewChild('pickerB') pickerB: NgxMatTimepickerComponent;

  selectFromTime(event) {
    this.minEndTime = DateTime.local()
      .startOf('day')
      .set({
        hour: +event.slice(0, event.length - 3) + 3,
        minute: 0,
      });
    this.isEndTimeSelectable = false;
    this.selectedFromTime;
  }
  selectEndTime(event) {
    this.selectedToTime = event;
    this.maxStartTime = DateTime.local()
      .startOf('day')
      .set({
        hour: +event.slice(0, event.length - 3) - 3,
        minute: 0,
      });
  }
  minDate: Date = new Date();
  maxDate: Date;
  @ViewChild('picker') picker: MatDatepicker<Date>;
  weekendFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0 && day !== 6;
  };

  dateSelected(ev) {
    this.selectedDate = new Date(ev.value);
  }
  selectedDate: Date;

  saveArrangePickUp() {
    if(this.checkArrangePickUpFormValidation() == false){

    let start_date = `${this.form.value.pickUpDate.getFullYear()}-${
      this.form.value.pickUpDate.getMonth() + 1
    }-${this.form.value.pickUpDate.getDate()} ${this.form.value.startTime}`;
    let end_date = `${this.form.value.pickUpDate.getFullYear()}-${
      this.form.value.pickUpDate.getMonth() + 1
    }-${this.form.value.pickUpDate.getDate()} ${this.form.value.endTime}`;
    const completePayload = {
      pick_up: {
        address_id: this.addressId,
        end_time: end_date,
        start_time: start_date,
      },
    };
    const labelPayload = {
      create_pick_up: true,
      order_id: this.shipment.id,
    };
    if (start_date && end_date) {
      this.signUpService
        .b2bArrangePickupComplete(this.token, this.shipment.id, completePayload)
        .pipe(
          switchMap((completeResponse) => {
            if (completeResponse['result']['status'] == 200) {
              return this.signUpService.b2bArrangePickupLabel(
                this.token,
                this.shipment.id,
                labelPayload
              );
            }
          })
        )
        .subscribe({
          next: (labelResponse) => {
            if (labelResponse['result']['status'] == 200) {
              const newShipmentData = labelResponse['data'];
              if (newShipmentData) {
                if (Object.keys(newShipmentData).length > 0) {
                  this.toastr.success(
                    'Pickup arranged successfully!',
                    'Success'
                  );
                  this.dialogRef.close(newShipmentData);
                }
              }
            } else {
              this.dialogRef.close(null);
              this.toastr.error(labelResponse['result']['message']);
              return;
            }
          },
          error: (err) => {
            this.toastr.error('Error arranging pickup!', 'Error');
            this.dialogRef.close(null);
          },
        });
    }
    }
  }

  checkArrangePickUpFormValidation() {
    let hasError = false;

    if (this.form.controls.pickUpDate.status == 'INVALID') {
      this.form.controls.pickUpDate.markAsTouched();
      this.toastr.error('Please select the Pick Up Date');
      hasError = true;
    }
    if (this.form.controls.startTime.status == 'INVALID') {
      this.form.controls.startTime.markAsTouched();
      this.toastr.error('Please select the Pick Up Start Hours');
      hasError = true;
    }
    if (this.form.controls.endTime.status == 'INVALID') {
      this.form.controls.endTime.markAsTouched();
      this.toastr.error('Please select the Pick Up End Hours');
      hasError = true;
    }
    return hasError;
  }

  onEditItem() {}
}
